import React from "react";
import gql from "graphql-tag";
import { RailsUrl } from "@services";
import { Flex, Button, Text, Box, Link } from "@atoms";
import { FundsPageWithdrawalsButtonFragment } from "./__generated__/FundsPageWithdrawalsButtonFragment";
import { useStoreAppValue } from "@hooks";
import { PaymentType } from "@types";

// == Types ================================================================

interface IProps {
  campaign: FundsPageWithdrawalsButtonFragment;
}

// == Constants ============================================================

FundsPageWithdrawalsButton.fragments = gql`
  fragment FundsPageWithdrawalsButtonFragment on Campaign {
    id
    hasBeneficiary
    isViewerOwner @include(if: $hasCurrentUser)
  }
`;

// == Component ============================================================

export default function FundsPageWithdrawalsButton({ campaign }: IProps) {
  const { paymentsUrl, newBeneficiaryUrl } = RailsUrl;
  const { hasBeneficiary, isViewerOwner } = campaign;
  const isWithdrawalReady = hasBeneficiary && isViewerOwner;
  const {
    featureFlags: { newBeneficiary },
  } = useStoreAppValue();

  if (!isViewerOwner) return null;

  if (!hasBeneficiary && isViewerOwner) {
    return (
      <Flex justifyContent="center" mt={2} mb={3} width={1}>
        {newBeneficiary ? (
          <Button as="a" href={RailsUrl.beneficiaryIntroUrl(campaign.id)}>
            <Text color="white" fontSize={[2, 3, 3]}>
              Submit Payment Info
            </Text>
          </Button>
        ) : (
          <Button as="a" href={newBeneficiaryUrl(campaign.id)}>
            <Text color="white" fontSize={[2, 3, 3]}>
              Submit Payment Info
            </Text>
          </Button>
        )}
      </Flex>
    );
  }

  return (
    <>
      <Flex justifyContent="center" mt={2} mb={3} width={1}>
        <Button
          variant={isWithdrawalReady ? "primary" : "disabled"}
          px={[2, 3, 4]}
          py={2}
          as="a"
          href={isWithdrawalReady ? paymentsUrl(campaign.id) : "#"}
        >
          <Text color="white" fontSize={[2, 3, 3]}>
            Withdraw Funds
          </Text>
        </Button>
      </Flex>
    </>
  );
}

// == Styles ===============================================================
